export default ({ COLORS }) => ({
  left: {
    textAlign: 'left'
  },
  date: {
    textAlign: 'left',
    width: '180px'
  }
})
